import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import saveExtended from "./saveExtended"

export default function updateLandingData( callBack?: () => void ) {
    const id = "86"
    useLandingStore.setState({ needUpdate: false })
    //TODO: server update action
    if( !useLandingStore.getState().isLocal ) {
        saveExtended( 
            JSON.stringify(
                {
                    ...useLandingStore.getState().currentLanding,
                    history: useLandingStore.getState().history,
                    currentHistoryStep: useLandingStore.getState().currentHistoryStep, 
                }
            ),
            id,
            "1",
            callBack
        )
    }
}